export default "__VITE_PUBLIC_ASSET__c45b64d7__"